import '../assets/NcHotkeyList-CNWXE5jg.css';
import { defineComponent } from "vue";
import { r as register, y as t30, a as t } from "./_l10n-DmTbp_o_.mjs";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
register(t30);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcHotkeyList",
  props: {
    label: { default: void 0 }
  },
  setup(__props) {
    const labelId = `NcHotkeyList_${createElementId()}`;
    return { __sfc: true, labelId, t };
  }
});
const hotkeyList = "_hotkeyList_W8veH";
const hotkeyList__heading = "_hotkeyList__heading_Dfekf";
const style0 = {
  hotkeyList,
  hotkeyList__heading
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: _vm.$style.hotkeyList }, [_c("div", { class: [_vm.$style.hotkeyList__heading, { "hidden-visually": !_vm.label }], attrs: { "id": _setup.labelId } }, [_vm._v(" " + _vm._s(_vm.label || _setup.t("Keyboard shortcuts")) + " ")]), _c("ul", { attrs: { "aria-labelledby": _setup.labelId } }, [_vm._t("default")], 2)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcHotkeyList = __component__.exports;
export {
  NcHotkeyList as N
};
//# sourceMappingURL=NcHotkeyList-BD8bukRV.mjs.map
